<template>
  <div class="page">
    <a
      href="javascript:;"
      class="tool-fullscreen noprint"
      @click="fullScreen($event)"
      ><span class="iconfont icon-fullscreen"></span
    ></a>
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h3 class="weui-form__title_en">WELCOME</h3>
        <h2 class="weui-form__title">{{ activity.sa_name }}</h2>
      </div>
      <div class="qrcode-area">
        <div class="qrcode-wrp">
          <h1 class="qrcode-title">签到登记</h1>
          <div class="qrcode-title__desc">
            <div class="qrcode-title__desc_text">Visit registration</div>
          </div>
          <img :src="qrcodeUrl" />
          <p class="weui-form__tips">请扫二维码</p>
        </div>
      </div>
      <div class="weui-form__text-area">
        <div class="weui-form__desc company-text">
          {{ activity.sa_organizer }}
        </div>
      </div>
    </div>
    <div class="weui-footer weui-footer_fixed-bottom">
      <div class="provider-info">
        <div class="copyright">
          <p>软硬件由华商数据科技有限公司提供</p>
          <p class="slogan">
            <span>华商云服连世界</span><span>助力企业通万家</span>
          </p>
        </div>
        <div class="weixin_qr">
          <img src="../../assets/images/usoft_weixin_qr.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import screen from "@/mixins/screen.js";

export default {
  data() {
    return {
      qrcodeUrl: null,
      activity: {
        sa_name: null,
        sa_organizer: null,
      },
    };
  },
  mixins: [screen],
  mounted() {
    this.getQrCode();
    document.documentElement.style.fontSize =
      (document.documentElement.clientWidth / 640) * 20 + "px";
  },
  methods: {
    getActivity() {
      var me = this,
        id = me.$route.params.id;
      return me
        .$loading({
          url: "/api/crm/activity/read/" + id,
        })
        .then(function (res) {
          if (res.data) {
            return res.data.main;
          }
        });
    },
    getQrCode() {
      var me = this;
      return me.getActivity().then(function (activity) {
        me.activity = activity;
        var link =
          window.location.origin +
          "/open/crm/activity/sign_edit?uid=" +
          activity.sa_uid;
        me.$ajax({
          url: "/api/commons/qrcode?url=" + encodeURIComponent(link),
          responseType: "blob",
        }).then(function (binaryData) {
          me.qrcodeUrl = URL.createObjectURL(binaryData);
        });
      });
    },
  },
};
</script>

<style scoped>
.page {
  background-color: #008ed6;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: justify;
}
.weui-form {
  width: 100%;
  min-height: 75%;
  background-color: #008ed6;
  padding: 0;
}
.weui-form__title_en {
  font-size: 1.4rem;
  color: #0ac7ff;
  letter-spacing: 0.4rem;
  margin-bottom: 10px;
}
.weui-form__title {
  max-width: 60vw;
  margin: 0 auto;
  font-size: 1.8rem;
  color: white;
  letter-spacing: 0.6rem;
}
.weui-form__desc {
  font-size: 1.4rem;
  color: white;
}
.weui-footer__link {
  font-size: 1rem;
}
.qrcode-area {
  display: flex;
  justify-content: center;
  text-align: center;
  margin: 2rem 0;
}
.qrcode-title {
  font-size: 1.8rem;
  letter-spacing: 0.4rem;
}
.qrcode-title__desc {
  border-top: 1px solid #b4d2e2;
  margin-top: 10px;
}
.qrcode-title__desc_text {
  position: relative;
  top: -0.8rem;
  padding: 0 0.55em;
  display: inline-block;
  vertical-align: middle;
  font-size: 0.8rem;
  line-height: 1.6;
  background-color: #fff;
  /* background-color: var(--weui-BG-2); */
  color: rgba(0, 0, 0, 0.5);
  /* color: var(--weui-FG-1); */
}
.qrcode-wrp {
  padding: 10px 3rem;
  max-width: 80vw;
  background-color: white;
  border-radius: 20px;
  border: 1px solid #008ed6;
}
.qrcode-wrp img {
  width: 10rem;
  height: 10rem;
  padding: 1rem;
  margin-bottom: 20px;
}
.company-text {
  font-size: 1.3rem;
  margin-top: 0;
  color: #ecfbff;
}
.provider-info {
  width: 80%;
  margin: 20px auto 0 auto;
  display: flex;
  justify-content: center;
}
.provider-info .copyright {
  line-height: 1.2rem;
  font-size: 0.5rem;
  letter-spacing: 0.1rem;
  margin: 0.4rem 1rem 0 0;
  color: #6fdff4;
}
.provider-info .slogan {
  display: flex;
  justify-content: space-between;
}
.weixin_qr {
  float: right;
}
.weixin_qr img {
  width: 3rem;
  height: 3rem;
  background-color: white;
}
.tool-fullscreen {
  position: absolute;
  top: 5px;
  right: 10px;
}
@media print {
  .noprint {
    visibility: hidden;
  }
}
.weui-form__tips {
  color:rgba(0,0,0,.5);
  /* color: var(--weui-FG-1); */
  font-size: 14px
}
</style>